import { appointmentAccessReasonEnumList } from '../../../components/AgGrid/enumLists'

const appointmentAccessReasonValueGetter = (props) => {
  const { value } = props
  return appointmentAccessReasonEnumList(value)
}

export default appointmentAccessReasonValueGetter
